import { render, staticRenderFns } from "./index.vue?vue&type=template&id=335b7c3e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('335b7c3e')) {
      api.createRecord('335b7c3e', component.options)
    } else {
      api.reload('335b7c3e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=335b7c3e", function () {
      api.rerender('335b7c3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileViewer/index.vue"
export default component.exports